export default {
  language_selector: {
    label: 'Choisir une langue',
  },
  nav_items: {
    home: 'Accueil',
    menu: 'Menu',
    locations: 'Adresses',
    store_info: 'Infos du magasin',
    rewards: 'Récompenses',
  },
};
